export * from './rateDetail';
